// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* label.MuiButtonBase-root.MuiButton-root.MuiButton-contained.MuiButton-containedPrimary.MuiButton-sizeMedium.MuiButton-containedSizeMedium.MuiButton-colorPrimary.MuiButton-root.MuiButton-contained.MuiButton-containedPrimary.MuiButton-sizeMedium.MuiButton-containedSizeMedium.MuiButton-colorPrimary.css-sghohy-MuiButtonBase-root-MuiButton-root {
  border-radius: 0px !important;
  background: transparent !important;
  box-shadow: none !important;
  border: 1px solid #007bc0 !important;
  color: #007bc0 !important;
  width: 180px !important;
  height: 55px;
  padding: 0px 17px 0px 12px !important;
  text-transform: none !important;
} */

.AlertImagetPosition {
  position: fixed;
  top: 95px;
  right: 10px;
  z-index: 10;
}

.ImgIten {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 186px;
  height: 40px;
  border: 0.5px solid #dbdbdb;
  background: #eff1f2;
  margin: 0px 10px 0px 0px;
  font-size: 14px;
}

.ImgItenContainer {
  display: flex;
  width: auto;
  align-items: center;
  flex-wrap: wrap;
}

.placeMenssage {
  margin-left: 10px;
  color: gray;
}

.tooltipWrapper {
  position: relative;
  display: inline-block;
}

.tooltipBox {
  visibility: hidden;
  opacity: 0;
  background-color: #fff;
  color: #333;
  font-weight: 700;
  text-align: left;
  padding: 6px 10px;
  position: absolute;
  z-index: 999;
  top: 120%; /* posição acima do elemento */
  left: 50%;
  transform: translateX(-50%);
  transition: opacity 0.2s ease-in-out;
  font-size: 12px;
  white-space: normal;
  min-width: 160px;
  max-width: 240px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

.tooltipWrapper:hover .tooltipBox {
  visibility: visible;
  opacity: 1;
}

/* .tooltipBox::after {
  content: "";
  position: absolute;
  top: 100%; 
  left: 50%;
  transform: translateX(-50%);
  border-width: 5px;
  border-style: solid;
  border-color: #fff transparent transparent transparent;
} */
`, "",{"version":3,"sources":["webpack://./src/componentes/fluxo-engenheiro/uploadImage/uploadImage.css"],"names":[],"mappings":"AAAA;;;;;;;;;;GAUG;;AAEH;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,2BAA2B;EAC3B,mBAAmB;EACnB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,SAAS,EAAE,8BAA8B;EACzC,SAAS;EACT,2BAA2B;EAC3B,oCAAoC;EACpC,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;;;;;;;;;GASG","sourcesContent":["/* label.MuiButtonBase-root.MuiButton-root.MuiButton-contained.MuiButton-containedPrimary.MuiButton-sizeMedium.MuiButton-containedSizeMedium.MuiButton-colorPrimary.MuiButton-root.MuiButton-contained.MuiButton-containedPrimary.MuiButton-sizeMedium.MuiButton-containedSizeMedium.MuiButton-colorPrimary.css-sghohy-MuiButtonBase-root-MuiButton-root {\n  border-radius: 0px !important;\n  background: transparent !important;\n  box-shadow: none !important;\n  border: 1px solid #007bc0 !important;\n  color: #007bc0 !important;\n  width: 180px !important;\n  height: 55px;\n  padding: 0px 17px 0px 12px !important;\n  text-transform: none !important;\n} */\n\n.AlertImagetPosition {\n  position: fixed;\n  top: 95px;\n  right: 10px;\n  z-index: 10;\n}\n\n.ImgIten {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 186px;\n  height: 40px;\n  border: 0.5px solid #dbdbdb;\n  background: #eff1f2;\n  margin: 0px 10px 0px 0px;\n  font-size: 14px;\n}\n\n.ImgItenContainer {\n  display: flex;\n  width: auto;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.placeMenssage {\n  margin-left: 10px;\n  color: gray;\n}\n\n.tooltipWrapper {\n  position: relative;\n  display: inline-block;\n}\n\n.tooltipBox {\n  visibility: hidden;\n  opacity: 0;\n  background-color: #fff;\n  color: #333;\n  font-weight: 700;\n  text-align: left;\n  padding: 6px 10px;\n  position: absolute;\n  z-index: 999;\n  top: 120%; /* posição acima do elemento */\n  left: 50%;\n  transform: translateX(-50%);\n  transition: opacity 0.2s ease-in-out;\n  font-size: 12px;\n  white-space: normal;\n  min-width: 160px;\n  max-width: 240px;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\n}\n\n.tooltipWrapper:hover .tooltipBox {\n  visibility: visible;\n  opacity: 1;\n}\n\n/* .tooltipBox::after {\n  content: \"\";\n  position: absolute;\n  top: 100%; \n  left: 50%;\n  transform: translateX(-50%);\n  border-width: 5px;\n  border-style: solid;\n  border-color: #fff transparent transparent transparent;\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
